(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (function() {
    function openFaqAccordion() {
      var el = document.getElementById('faq-member-already');
      if (!el) return false;
      if (el.hasAttribute('open')) return true; // already open

      var summary = el.querySelector('summary');
      if (!summary) return false;

      summary.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));

      return el.hasAttribute('open');
    }

    function handleHash() {
      if (window.location.hash !== '#faq-member-already') return;

      var attempts = 0;
      var interval = setInterval(function() {
        attempts++;
        var success = openFaqAccordion();
        if (success || attempts >= 20) {
          clearInterval(interval);
        }
      }, 150); // retry every 150ms, up to 20 times (3 seconds total)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleHash);
    } else {
      setTimeout(handleHash, 50);
    }

    window.addEventListener('hashchange', handleHash);
  })();
  } catch(e) { console.error(e); }
})();

})();
